export const phoneFormat = (str) => {
  if (!str) {
    return ''
  }

  let phone = str.trim()

  // If the string already has the desired format, then we return it as is
  if (!phone && phone.match(/^\+?\d{1,5} \(\d{3}\) \d{3}-\d{2}-\d{2}$/)) {
    return phone
  }

  // Remove all the characters of spaces, brackets and hyphens
  phone = phone.replace(/[\s()-]/g, '')

  // Check if the string matches the format of a number containing 11-15 digits
  if (phone.match(/^\+?\d{11,15}$/)) {
    return phone.replace(
      /(\d{3})(\d{3})(\d{2})(\d{2})$/,
      ' ($1) $2-$3-$4'
    )
  } else {
    // Return the original string if it does not match the format
    return str.trim()
  }
}

export const getFormattedPhones = (phoneNumbers) => {
  if (!Array.isArray(phoneNumbers)) {
    return []
  }

  return phoneNumbers.map(phoneFormat)
}
